export var isForce = function isForce(layoutType) {
  return layoutType === 'force' || layoutType === 'g6force' || layoutType === 'gForce' || layoutType === 'force2';
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/g6-core/es/util/layout.js
// module id = null
// module chunks = 